// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__F9A4V","footer":"ModalError_footer__12MO-"};